import exportFromJSON from "export-from-json";

export const downloadXl = (json) => {
  const fileName = "nispand-file";
  const exportType = "xls";
  exportFromJSON({ data: json, fileName, exportType });
};
